import React, { useState } from "react";

// ImageWithFallback component directly included
const ERROR_IMG_SRC =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==";

function ImageWithFallback(props) {
  const [didError, setDidError] = useState(false);

  const handleError = () => {
    setDidError(true);
  };

  const { src, alt, style, className, ...rest } = props;

  return didError ? (
    <div
      className={`image-fallback-container ${className || ""}`}
      style={style}
    >
      <div className="fallback-content">
        <img
          src={ERROR_IMG_SRC}
          alt="Error loading image"
          {...rest}
          data-original-url={src}
        />
      </div>
    </div>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      {...rest}
      onError={handleError}
    />
  );
}

// Button component directly included
function Button({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}) {
  const Comp = asChild ? "span" : "button";

  const baseStyles =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-blue-500 focus-visible:ring-2 focus-visible:ring-blue-500/50";

  const variantStyles = {
    default: "bg-blue-500 text-white hover:bg-blue-600",
    destructive: "bg-red-500 text-white hover:bg-red-600",
    outline: "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
    secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300",
    ghost: "hover:bg-gray-100 hover:text-gray-900",
    link: "text-blue-500 underline-offset-4 hover:underline",
  };

  const sizeStyles = {
    default: "h-9 px-4 py-2",
    sm: "h-8 rounded-md px-3 text-xs",
    lg: "h-10 rounded-md px-6",
    icon: "w-9 h-9 rounded-md",
  };

  const buttonClass = `${baseStyles} ${variantStyles[variant]} ${
    sizeStyles[size]
  } ${className || ""}`;

  return <Comp className={buttonClass} {...props} />;
}

export function AgentSidebarItem({
  agent,
  isSelected,
  onSelect,
  onExclude,
  isDisabled,
  selectedAgents,
}) {
  return (
    <div className="sidebar-item">
      {/* Circular Image with border */}

      <div
        className={`sidebar-image-container ${isSelected ? "selected" : ""}`}
      >
        <div
          className={` ${
            !["Charlotte", "Ethan", "Alex", "Sterling"].includes(agent.name)
              ? "opacity-60 pointer-events-none"
              : ""
          }`}
        >
          <div className="sidebar-image-wrapper">
            <ImageWithFallback
              src={agent.image}
              alt={agent.name}
              className="sidebar-agent-image"
            />
          </div>
        </div>
      </div>

      {/* Agent Name */}
      <div className="sidebar-agent-info">
        <p className="sidebar-agent-name">{agent.name}</p>
        <p className="sidebar-agent-title">{agent.title}</p>
      </div>

      {/* Action Button */}
      {isSelected ? (
        <Button
          onClick={() => onExclude && onExclude(agent.id)}
          variant="destructive"
          disabled={selectedAgents.length <= 2 ? true : false}
          size="sm"
          className="exclude-button"
        >
          Exclude
        </Button>
      ) : (
        <Button
          onClick={() => onSelect && onSelect(agent)}
          disabled={isDisabled}
          variant="default"
          size="sm"
          className={`select-sidebar-button ${
            !["Charlotte", "Ethan", "Alex", "Sterling"].includes(agent.name)
              ? " pointer-events-none"
              : ""
          }`}
        >
          {/* Select */}
          {["Charlotte", "Ethan", "Alex", "Sterling"].includes(agent.name)
            ? "Select"
            : "Contact for Access"}
        </Button>
      )}
    </div>
  );
}
